/** Gram display with exactly 3 digits after the decimal (e.g. 2.500g). */
export function formatWeightGrams3(value) {
  const n = parseFloat(String(value ?? '').replace(/,/g, ''));
  if (!Number.isFinite(n)) return '0.000';
  return n.toFixed(3);
}

/**
 * Group pledged rows by master article type (e.g. Gold vs Silver) for weight totals.
 * @param {Array} pledgeArticles - pledge.articles from API
 * @param {Array} masterArticles - list from /articles with _id and title
 * @returns {{ title: string, totalGrossWeight: number, totalNetWeight: number }[]}
 */
export function computeArticleTypeWeightTotals(pledgeArticles, masterArticles) {
  const articleTypeTotals = {};
  (pledgeArticles || []).forEach((article) => {
    let articleId = article.articleId;
    if (articleId && typeof articleId === 'object') {
      articleId = articleId._id != null ? String(articleId._id) : String(articleId);
    } else {
      articleId = articleId != null ? String(articleId) : '';
    }
    if (!articleId) return;
    const articleInfo = (masterArticles || []).find((a) => String(a._id) === articleId);
    const articleTitle = articleInfo ? articleInfo.title : 'Unknown';
    if (!articleTypeTotals[articleId]) {
      articleTypeTotals[articleId] = {
        title: articleTitle,
        totalGrossWeight: 0,
        totalNetWeight: 0,
      };
    }
    articleTypeTotals[articleId].totalGrossWeight +=
      parseFloat(String(article.grossWeight ?? article.grossWt ?? '').replace(/,/g, '')) || 0;
    articleTypeTotals[articleId].totalNetWeight +=
      parseFloat(String(article.netWeight ?? article.netWt ?? '').replace(/,/g, '')) || 0;
  });
  return Object.values(articleTypeTotals).sort((a, b) =>
    (a.title || '').localeCompare(b.title || '', undefined, { sensitivity: 'base', numeric: true })
  );
}
